module.exports = __webpack_public_path__ + "static/icons/icon-map--turkey-365b0564211583218f40a398a16e50d9.svg";